import type { IntlShape } from 'react-intl'

interface BundleLocationCaptionParts {
  locationHeading?: string
  locationSubheading?: string
}

export function formatBundleLocationLabel(
  intl: IntlShape,
  { locationHeading, locationSubheading }: BundleLocationCaptionParts,
): string {
  if (locationHeading && locationSubheading) {
    return intl.formatMessage(
      {
        id: '5o5ukOv0J1tl0l2-Ox6S',
        defaultMessage: '{locationHeading}, {locationSubheading}',
        description: 'Bundle location label with location heading and subheading separated by a comma',
      },
      { locationHeading, locationSubheading },
    )
  }

  return locationHeading || locationSubheading || ''
}

export default function formatBundleLocationCaption(
  intl: IntlShape,
  locations: Array<BundleLocationCaptionParts>,
): string {
  const locationLabels = locations
    .map((location) => formatBundleLocationLabel(intl, location))
    .filter(Boolean)

  if (locationLabels.length === 0) {
    return ''
  }

  return intl.formatList(locationLabels, { type: 'conjunction', style: 'short' })
}
